import { Button } from "@tql/ui-components-react/tql/buttons";
import { shieldTick } from "@tql/ui-components-react/untitled/icons";

import type { QuoteStateType } from "~/shared/types/quote-details-types.ts";

const hasInsurance = (quoteState: QuoteStateType): boolean => {
	return Boolean(
		quoteState.insuranceValue &&
		quoteState.insuranceValue > 0 &&
		quoteState.insuranceProductTypeId &&
		quoteState.insuranceApplyTypeId,
	);
};

type AddInsuranceProps = {
	handleRemoveInsuranceClick: () => void;
	hasCarriers: boolean;
	isAddInsuranceEnabled: boolean;
	isRemovingInsurance: boolean;
	quoteState: QuoteStateType;
	toggleModal: (modal: string) => void;
};

export const AddInsurance = ({
	handleRemoveInsuranceClick,
	hasCarriers,
	isAddInsuranceEnabled,
	isRemovingInsurance,
	quoteState,
	toggleModal,
}: Readonly<AddInsuranceProps>) => {
	if (!isAddInsuranceEnabled) return null;

	return (
		<div>
			{hasInsurance(quoteState) ? (
				<Button
					disabled={!hasCarriers}
					loading={isRemovingInsurance}
					onClick={() => handleRemoveInsuranceClick()}
					svgIcon={shieldTick}
					variant={"tertiary"}
				>
					Remove Insurance
				</Button>
			) : (
				<Button
					disabled={!hasCarriers}
					onClick={() => toggleModal("addInsurance")}
					svgIcon={shieldTick}
					variant={"tertiary"}
				>
					Add Insurance
				</Button>
			)}
		</div>
	);
};
